"use strict";
/**
 * FilterCard
 * A group of checkboxes within a category.
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterCard = void 0;
var react_1 = __importDefault(require("react"));
var storm_ui_1 = require("@amzn/storm-ui");
var extender_1 = require("../Extender/extender");
var filter_card_styles_1 = require("./filter_card.styles");
var filter_checkbox_1 = require("./filter_checkbox");
var FilterCard = function (props) {
    var _a;
    var categoryFilterLabels = props.categoryFilterLabels, categoryFilters = props.categoryFilters, extenderLabelAll = props.extenderLabelAll, extenderLabelFewer = props.extenderLabelFewer, setAppliedFilters = props.setAppliedFilters, publishMetrics = props.publishMetrics;
    var isMobile = (0, storm_ui_1.useIsMobile)();
    var idCategory = (_a = categoryFilterLabels === null || categoryFilterLabels === void 0 ? void 0 : categoryFilterLabels.label) === null || _a === void 0 ? void 0 : _a.toLowerCase().replace(' ', '-');
    var updateFiltersCallback = function (newFilter) {
        setAppliedFilters(function (prev) {
            return prev.map(function (currentFilter) {
                if (currentFilter.value === newFilter.value) {
                    return __assign({}, newFilter);
                }
                return __assign({}, currentFilter);
            });
        });
    };
    var checkboxItems = categoryFilterLabels.options.map(function (option, i) {
        return (react_1.default.createElement(filter_card_styles_1.CheckboxContainer, { key: i },
            react_1.default.createElement(filter_checkbox_1.FilterCheckbox, { categoryFilters: categoryFilters, checkboxLabel: option.label, checkboxValue: option.value, id: "checkbox-".concat(option.label.toLowerCase().replace(' ', '-')), setAppliedFilters: updateFiltersCallback, publishMetrics: publishMetrics })));
    });
    var cardWithoutExtender = (react_1.default.createElement(storm_ui_1.CheckboxGroup, { label: categoryFilterLabels.label, "aria-label": categoryFilterLabels.label }, checkboxItems));
    var cardWithExtender = (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(storm_ui_1.CheckboxGroup, { label: categoryFilterLabels.label, "aria-label": categoryFilterLabels.label }, checkboxItems === null || checkboxItems === void 0 ? void 0 :
            checkboxItems.slice(0, 5),
            react_1.default.createElement(extender_1.Extender, { expandLabel: extenderLabelAll, collapseLabel: extenderLabelFewer }, checkboxItems === null || checkboxItems === void 0 ? void 0 : checkboxItems.slice(5)))));
    return (react_1.default.createElement(react_1.default.Fragment, null, isMobile ? (react_1.default.createElement(filter_card_styles_1.MobileFilterCardContainer, { "data-testid": "filter-".concat(idCategory) },
        react_1.default.createElement(filter_card_styles_1.FilterCardContent, { "data-testid": "filter-".concat(idCategory) }, cardWithoutExtender))) : (react_1.default.createElement(filter_card_styles_1.FilterCardContent, null, checkboxItems && checkboxItems.length > 5 ? cardWithExtender : cardWithoutExtender))));
};
exports.FilterCard = FilterCard;
